// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1F2IG","filesListContainer":"PosDisputesFiles_filesListContainer__URXMX","filesButton":"PosDisputesFiles_filesButton__2SBsO"};